import axios from "axios";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.css";

const RegistrationForm = () => {
  const [form, setForm] = useState({
    title: "",
    firstName: "",
    lastName: "",
    companyName: "",
    designation: "",
    email: "",
    mobile: "",
    address: "",
    industrySector: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/form/register`,
        form,
      );

      const objectId = response.data.data._id;

      if (response.status === 201) {
        toast.success("Registration Successfull!", { position: "top-right" });
        setTimeout(() => {
          navigate(`/ebadge/${objectId}`);
        }, 3000);
        // Optional: Clear the form
        setForm({
          title: "",
          firstName: "",
          lastName: "",
          companyName: "",
          designation: "",
          email: "",
          mobile: "",
          address: "",
          industrySector: "",
        });
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="body">
        <ToastContainer />
        <Helmet prioritizeSeoTags>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-LXH7EJW8SS"
          ></script>
          <script type="text/javascript">
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-LXH7EJW8SS');
          `}
          </script>
        </Helmet>
        <div className="container">
          <div className="header"></div>
          <div className="title">
            <h4>Visitor Registration</h4>
            <hr />
          </div>
          <div className="content">
            <form onSubmit={handleSubmit}>
              <div className="user-details">
                <div className="input-box">
                  <span className="details">
                    First Name
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="Enter your first name"
                    value={form.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="input-box">
                  <span className="details ">
                    Last Name{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Enter your last name"
                    name="lastName"
                    value={form.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="user-details"></div>

              <div className="user-details">
                <div className="input-box">
                  <span className="details">
                    Company{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Enter your company name"
                    name="companyName"
                    value={form.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="input-box">
                  <span className="details">
                    Designation{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Enter your designation"
                    name="designation"
                    value={form.designation}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="input-box">
                  <span className="details">
                    Email{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    className="input--style-5"
                    type="email"
                    placeholder="Enter your email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2, 4}$"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-box">
                  <span className="details">
                    Mobile{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="tel"
                    placeholder="Enter your mobile"
                    required
                    name="mobile"
                    value={form.mobile}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^[6-9][0-9]{0,9}$/.test(input) || input === "") {
                        setForm({ ...form, mobile: input });
                      }
                    }}
                    maxLength={10}
                  />
                </div>

                <div className="input-box">
                  <span className="details">
                    Address{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Enter your address"
                    required
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="input-box">
                  <span className="details">
                    Industry Sector{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    >
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Enter industry sector"
                    required
                    name="industrySector"
                    value={form.industrySector}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="button">
                <button
                  type="submit"
                  disabled={loading}
                  className={loading ? "loading" : ""}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Registering...
                    </>
                  ) : (
                    "Register"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationForm;
